import {range, sortBy} from 'lodash'
import React, { useContext } from 'react'

import {TeacherContext} from 'teacher/context'

import SearchPattern from 'components/search-pattern'
import LanguageFilter from 'components/language-filter'
import GradeFilter from 'components/grade-filter'

import Course from './course'
import './catalogue-courses.styl'


export default function CatalogueCourses () {
  const context = useContext(TeacherContext)
  
  const {sizes} = context

  const selectedGrade = context.query.grade || context.grade

  const [subjectInfo, availableLanguages, ...catalogueCourses] = context.catalogueCourses

  const courses = (selectedGrade
    ? catalogueCourses.filter(({grade}) => grade == selectedGrade)
    : sortBy(catalogueCourses, [({grade}) => context.gradePrecedence[grade] , 'id'])
  )

  const coursesPerRow = Math.floor((sizes.width  - 48) / 235)
  const fillersNeeded = coursesPerRow - courses.length % coursesPerRow

  return (
    <div className="catalogue-courses">
      <div className="filters-wrapper">
        <div className="filters">
          <div className="back" onClick={() => navigateBack(context)}/>
          <div className="subject-name">
            { subjectInfo && (<div className="label">{subjectInfo.name}</div>)}
          </div>
          <SearchPattern />
          <LanguageFilter {...availableLanguages} />
        </div>
      </div>
      <div className="content">
        <GradeFilter />
        <div className="courses">
          {courses.map(course => <Course key={course.id} {...course} />)}
          {range(fillersNeeded).map(key => <div key={key} className="course filler" />)}
        </div>
      </div>
    </div>)

}

function navigateBack (context) {
  const query = {languageId: context.query.languageId}
  context.navigate({subject: null}, context.match.path, {query}) 
}